// Brief loading flag that flips true for `ms` whenever `deps` change (skipping
// the first render). Used to show a short skeleton/shimmer when a filter or
// period toggle changes, so data swaps feel intentional. From the prototype.
import { useEffect, useRef, useState } from 'react';

export function useFilterLoading(deps, ms = 280) {
  const [loading, setLoading] = useState(false);
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return undefined;
    }
    setLoading(true);
    const t = setTimeout(() => setLoading(false), ms);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return loading;
}

export default useFilterLoading;
